/**
 * @module modules/commit-detail-sk
 * @description <h2><code>commit-detail-sk</code></h2>
 *
 * An element to display information around a single commit.
 *
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CommitDetailSk", {
    enumerable: true,
    get: function() {
        return CommitDetailSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _human = require("../../../infra-sk/modules/human");
const _query = require("../../../infra-sk/modules/query");
const _json = require("../json");
require("@material/web/button/outlined-button.js");
const _commit = require("../common/commit");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
// The range of time (in seconds) to display around a specific commit in the Explore view.
// +/- 4 days provides a reasonable window to see context.
const FOUR_DAYS_IN_SECONDS = 4 * 24 * 60 * 60;
let CommitDetailSk = class CommitDetailSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        return (0, _lit.html)`
      <div class="linkish">
        <pre>
${(0, _commit.TrimHash)(this.cid.hash)} - ${this.cid.author} - ${(0, _human.diffDate)(this.cid.ts * 1000)} - ${this.cid.message}</pre
        >
        <div class="tip">
          <md-outlined-button
            @click=${()=>{
            if (this.trace_id) {
                const query = {
                    begin: this.cid.ts - FOUR_DAYS_IN_SECONDS,
                    end: this.cid.ts + FOUR_DAYS_IN_SECONDS,
                    keys: this.trace_id,
                    num_commits: 50,
                    request_type: 1,
                    xbaroffset: this.cid.offset
                };
                this.openLink(`/e/?${(0, _query.fromObject)(query)}`);
            } else {
                this.openLink(`/g/e/${this.cid.hash}`);
            }
        }}>
            Explore
          </md-outlined-button>
          <md-outlined-button @click=${()=>this.openLink(`/g/c/${this.cid.hash}`)}>
            Cluster
          </md-outlined-button>
          <md-outlined-button @click=${()=>this.openLink(`/g/t/${this.cid.hash}`)}>
            Triage
          </md-outlined-button>
          <md-outlined-button @click=${()=>this.openLink(this.cid.url)}>
            Commit
          </md-outlined-button>
        </div>
      </div>
    `;
    }
    openLink(link) {
        window.open(link, '_blank');
    }
    constructor(...args){
        super(...args);
        this.cid = {
            author: '',
            message: '',
            url: '',
            ts: 0,
            hash: '',
            offset: (0, _json.CommitNumber)(0),
            body: ''
        };
        this.trace_id = '';
    }
};
_ts_decorate([
    (0, _decorators.property)({
        type: Object
    }),
    _ts_metadata("design:type", typeof _json.Commit === "undefined" ? Object : _json.Commit)
], CommitDetailSk.prototype, "cid", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: String
    }),
    _ts_metadata("design:type", String)
], CommitDetailSk.prototype, "trace_id", void 0);
CommitDetailSk = _ts_decorate([
    (0, _decorators.customElement)('commit-detail-sk')
], CommitDetailSk);
